import { formatNumber } from './format-number';

const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;

/**
 * Format a file size in bytes to a human-readable string.
 * @param {number} size - The size in bytes.
 * @param {number} [digits=2] - The number of decimal places to include.
 * @returns {string} The formatted file size.
 *
 *  @example
 * ```typescript
 *  formatFileSize(1024); // "1.00 KB"
 *  formatFileSize(123456789); // "117.74 MB"
 *  formatFileSize(1048576, 3); // "1.000 MB
 * ```
 */
export const formatFileSize = (size: number, digits = 2) => {
  const index = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

  return `${formatNumber(size / 1024 ** index, {
    settings: {
      maximumFractionDigits: digits,
    },
  })} ${sizes[index]}`;
};
